<p-toast position="top-right" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
  [rejectVisible]="false"></p-confirmDialog>

<div class="d-flex justify-content-center">
  <div class="container-fluid" style="width: 88%;">
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-list mt-3" style="font-size: 1.7rem; color: #fff;"></i>
            </div>
            <header style="left: 11%; top: 5%;">Catalogos soporte</header>

          </div>
          <div class="card-content">
            <div class="row mt-3">
              <p-table #dt1 [value]="lstsoporte" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm"
                [scrollable]="true" scrollHeight="480px" responsiveLayout="scroll" [globalFilterFields]="['nombre','descripcion','usuario_registro','usuario_registro','clave_ruta',
                                'nombre_responsable']" [paginator]="true" [rows]="50"
                [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
                currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros" [loading]="loading"
                sortField="desc_ciudad">
                <ng-template pTemplate="caption">


                  <div class="row d-flex justify-content-end">
                    <!-- Botón a la derecha -->
                    <div class="col-12 sm:col-6 md:col-3 lg:col-3 xl:col-2 ">
                      <button type="button" class="custom-out form-control" (click)="Agregar();"
                        pTooltip="Agregar nuevo registro" tooltipPosition="top">
                        <b>Registrar&nbsp;<i class="pi pi-plus-circle"></i></b>
                      </button>
                    </div>

                    <!-- Filtro a la derecha, al lado del botón -->
                    <div class="col-auto mt-2">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" style="margin-left: 5px;"></i>
                        <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')"
                          placeholder="Buscar" style="margin-left: 5px;" />
                      </span>
                    </div>
                  </div>

                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-center" >#</th>
                    <th pSortableColumn="desc_ruta">Nombre<p-sortIcon field="desc_ruta"></p-sortIcon></th>
                    <th pSortableColumn="num_kilometros">Descripcion<p-sortIcon field="num_kilometros"></p-sortIcon>
                    </th>
                    <th>Usuario</th>
                    <th class="text-center">Fecha de registro</th>
                    <th class="text-center" pSortableColumn="estatus">Estatus<p-sortIcon field="estatus"></p-sortIcon></th>
                    <th style="width: 150px;"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-ruta let-index="rowIndex">
                  <tr>
                    <td class="text-center"><b>{{index + 1}}</b></td>
                    <td style="color:#3b9be9"><b> {{ruta.nombre}}</b></td>
                    <td >{{ruta.descripcion}}</td>
                    <td style="color:#5F9EA0"><b>{{ruta.nom_usuario}}</b></td>
                    <td class="text-center">{{ruta.fec_registro}}</td>
                    <td class="text-center" [ngStyle]="{'color': ruta.estatus == 1 ? '#3b9be9' : '#e94c3b'}"><b>
                        {{ ruta.estatus == 1 ? 'Activo' : 'Inactivo' }}</b>
                    </td>


                    <td style="width: 150px;">
                      <div class="d-flex justify-content-around gap-3">
                        <button pButton pRipple class="custom-change" pTooltip="Editar Informacion"
                          tooltipPosition="top" (click)="Editar(ruta)">
                          <b>Editar</b>
                          <i class="pi pi-pencil" style="margin-left: 5px;"></i>
                        </button>
                        <button pButton pRipple class="custom-outagg" pTooltip="Cambiar estatus"
                          tooltipPosition="top" (click)="cambiarestatus(ruta)">
                          <b>Estatus</b>
                          <i class="pi pi-arrow-right-arrow-left" style="margin-left: 5px;"></i>
                        </button>


                      </div>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>
            <!-- <div class="row mt-3 d-flex justify-content-center">
              <div class="col-6">
                <div class="mt-3">
                  <p-colorPicker [(ngModel)]="color_rojo_especial" [disabled]="true"></p-colorPicker>
                  <p class="text-left informativo" style="display: inline;">Rutas Especiales</p>
                </div>
                <div class="mt-3 mb-2">
                  <p-colorPicker [(ngModel)]="color_gris_deshabilitadas" [disabled]="true"></p-colorPicker>
                  <p class="text-left informativo" style="display: inline;">Ruta INACTIVA</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>







  <!--AGREGAR catalogo-->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspAgregar" [style]="{width: '55vw','height':'500px'}"
    (onHide)="cancelaragregar()" [transitionOptions]="'0ms'" styleClass="card-shadow">
    <ng-template pTemplate="header">
      Registro
    </ng-template>
    <ng-template pTemplate="content">
      <form class="form_cliente" [formGroup]="foliosForm" (ngSubmit)="guardar()">
        <div class="row  pb-2">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Agrege la informacion solicitada
                <i class="pi pi-cog" style="size: 2rem;">
                </i>
              </span>
            </div>
          </div>




          <div class=" col-md-6 mt-3">
            <div class="row g-0">
              <div class="col-sm-6 d-flex align-items-center">
                <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 1.5rem"></i>
                  <p class="ml-1 d-inline" style="color: #1e5a9c;"><b>Nombre del Soporte</b></p>
                </span>
              </div>
              <div class="mt-2">
                <input type="string" class="form-control sinborde"  tooltipPosition="top"
                  formControlName="nombre" style="text-transform:uppercase;">
                <hr style="border: none; border-top: 2px solid #1e5a9c; font-weight: bold;" class="my-0">

              </div>
            </div>

          </div>


          <div class="col-md-6">
            <label style="color: #1e5a9c; font-weight: bold;">Descripción</label>
            <div class="d-flex">
              <textarea rows="4" cols="70" pInputTextarea formControlName="descripcion"
                style="border-radius: 10px; border: 2px solid #1e5a9c; padding: 10px;">
          </textarea>
            </div>
          </div>

        </div>

        <div class="mt-8 d-flex justify-content-center">
          <button type="submit" class="custom-sinout" pTooltip="Registrar Soporte"><b>Guardar</b></button>
        </div>
      </form>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelaragregar();"></button>
    </ng-template>
  </p-dialog> <!--FIN AGREGAR PRESTAMO-->






  <!--editar catalogo-->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspeditar" [style]="{width: '55vw','height':'500px'}"
    (onHide)="cancelaragregar()" [transitionOptions]="'0ms'" styleClass="card-shadow">
    <ng-template pTemplate="header">
      Registro
    </ng-template>
    <ng-template pTemplate="content">
      <form class="form_cliente" [formGroup]="foliosForm" (ngSubmit)="guardareditar()">
        <div class="row  pb-2">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Agrege la informacion solicitada
                <i class="pi pi-cog" style="size: 2rem;">
                </i>
              </span>
            </div>
          </div>




          <div class=" col-md-6 mt-3">
            <div class="row g-0">
              <div class="col-sm-6 d-flex align-items-center">
                <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 1.5rem"></i>
                  <p class="ml-1 d-inline" style="color: #1e5a9c;"><b>Nombre del Soporte</b></p>
                </span>
              </div>
              <div class="mt-2">
                <input type="string" class="form-control sinborde" 
                  formControlName="nombre" style="text-transform:uppercase;">
                <hr style="border: none; border-top: 2px solid #1e5a9c; font-weight: bold;" class="my-0">

              </div>
            </div>

          </div>


          <div class="col-md-6">
            <label style="color: #1e5a9c; font-weight: bold;">Descripción</label>
            <div class="d-flex">
              <textarea rows="4" cols="70" pInputTextarea formControlName="descripcion"
                style="border-radius: 10px; border: 2px solid #1e5a9c; padding: 10px;">
          </textarea>
            </div>
          </div>

        </div>

        <div class="mt-8 d-flex justify-content-center">
          <button type="submit" class="custom-sinout" pTooltip="Registrar Soporte"><b>Guardar</b></button>
        </div>
      </form>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelaragregar();"></button>
    </ng-template>
  </p-dialog> <!--FIN AGREGAR PRESTAMO-->





</div>
